export const PERMISSIONS = {
  dashboardRead: 'dashboard.read',
  membersRead: 'members.read',
  membersWrite: 'members.write',
  rolesManage: 'roles.manage',
  siteRead: 'site.read',
  siteWrite: 'site.write',
  sitePublish: 'site.publish',
  pagesManage: 'pages.manage',
  homeManage: 'home.manage',
  productsManage: 'products.manage',
  productsPublish: 'products.publish',
  projectsManage: 'projects.manage',
  projectsPublish: 'projects.publish',
  solutionsManage: 'solutions.manage',
  solutionsPublish: 'solutions.publish',
  documentsManage: 'documents.manage',
  faqManage: 'faq.manage',
  inquiriesManage: 'inquiries.manage',
  mediaManage: 'media.manage',
  auditRead: 'audit.read',
} as const;

export const MENU_PERMISSIONS = {
  dashboard: 'menu.dashboard',
  siteSettings: 'menu.site-settings',
  home: 'menu.home',
  products: 'menu.products',
  designYours: 'menu.design-yours',
  projects: 'menu.projects',
  solutions: 'menu.solutions',
  afterSales: 'menu.after-sales',
  quality: 'menu.quality',
  aboutUs: 'menu.about-us',
  resources: 'menu.resources',
  process: 'menu.process',
  faq: 'menu.faq',
  contact: 'menu.contact',
  media: 'menu.media',
} as const;

export type PermissionCode = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
export type MenuPermissionCode = (typeof MENU_PERMISSIONS)[keyof typeof MENU_PERMISSIONS];
